<template>
  <div class="discussBox" ref="discussBox" id="discussBox">
    <h4 class="tit">
      <em>{{ $t("common.allCommentTit") }}</em>
      <span class="commentCount" v-if="commentCount != '0'">{{
        commentCount
      }}</span>
    </h4>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        :finished-text="$t('common.noneMore')"
      >
        <div class="list-item">
          <van-cell v-for="item in commentlists" :key="item.id" class="item">
            <div class="critic">
              <dl class="criticInfo">
                <dt class="criticImg">
                  <img :src="item.avatar" alt />
                </dt>
                <dd class="criticName">{{ item.creatorName }}</dd>
                <dd class="criticmain">{{ item.comment }}</dd>
              </dl>
              <span class="criticTime">{{ item.createTime.substr(5, 5) }}</span>
              <div class="criticLike" @click="handleClick(item)">
                <span
                  :class="[
                    'criticLikeIcon',
                    'iconfont',
                    item.isLike ? ['red', 'icon-dianzan3'] : 'icon-dianzan',
                  ]"
                ></span>
                <span class="criticCount" v-if="item.likes !== '0'">{{
                  item.likes
                }}</span>
              </div>
            </div>
          </van-cell>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";

export default {
  name: "discussBox",
  props: ["ktId", "showtype"],
  data() {
    return {
      newsType: "", //新闻type
      commentlists: [],
      backstagelists: [],
      applists: [],
      commentCount: 0,
      contentId: "", //评论所属id
      countType: "xw", //评论所属type
      page: 0,
      pageSize: 10,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据

      clientType: "", //手机类型
    };
  },

  mounted() {
    window.getDiscuss = this.getDiscuss;
    window.commentReload = this.reloadPage;

    this.newsType =
      this.$route.query.newsType == "" ||
      this.$route.query.newsType == undefined
        ? "other"
        : this.$route.query.newsType;
    this.clientType = getDeviceType();
    this.$nextTick(() => {
      this.contentId = this.ktId;
      if (this.newsType == "other") {
        this.discussShow();
      }
      this.getTest();
    });
  },
  methods: {
    //渲染评论列表
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.Review.DiscussDetail({
        pageNum: _this.page,
        pageSize: _this.pageSize,
        contentId: _this.contentId,
        commentType: _this.countType,
      })
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            // _this.setReview(total);
            _this.backstagelists = res.data.list;
            _this.commentCount = res.data.total;
            _this.viewLists();
            // 加载状态结束
            _this.loading = false;
            if (_this.page * 10 >= total) {
              _this.finished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.commentlists = this.commentlists.concat(this.backstagelists);
      if (this.commentlists.length < 3) {
        document.getElementById("list-content").style.height = 355 + "px"; //调整上拉加载框高度
      }
    },
    handleClick(item) {
      let _this = this;
      // 已经点过赞了
      if (item.isLike) {
        //取消点赞
        _this.$api.Review.DiscussBad(item.likeId)
          .then((res) => {
            if (res.code == "1") {
             
              item.likes--;
              console.log(parseInt(item.likes));
              if (parseInt(item.likes) < 0) {
                item.likes = 0;
              }
              _this.$toast(_this.$t("common.cencelGoodLike"));
            } else {
              console.log(res.msg);
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        //新增点赞
        _this.$api.Review.DiscussGood({
          likeId: item.id,
          likeType: "pl",
        })
          .then((res) => {
            if (res.code == "1") {
              item.likeId = res.data.id;
              item.likes++;
              _this.$toast(_this.$t("common.goodLike"));
            } else {
              console.log(res.msg);
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      _this.$set(item, "isLike", !item.isLike);
    },
    getDiscuss: function () {
      //获取div距离顶部的距离
      var mTop = this.$refs.discussBox.offsetTop;
      //减去滚动条的高度
      var sTop = document.body.scrollTop;
      var result = mTop - sTop;
      document.body.scrollTop = result;
    },
    discussShow() {
      //获取评论框
      if (this.clientType == "android") {
        window.android.getInfo(103, "");
      } else {
        //IOS
        window.webkit.messageHandlers.getCommentBox.postMessage(null);
      }
    },
    reloadPage: function () {
      this.page = 0;
      this.commentlists = [];
      setTimeout(() => {
        // this.getLike();
        this.getTest();
      }, 300);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 300);
    },
    //传递评论总条数
    setReview(total) {
      let _this = this;
      // _this.$emit("setReview", total);
      //将评论数返还给App
      if (_this.clientType == "android") {
        //安卓
        window.android.getInfo(110, total); //传递评论总条数
      } else {
        //IOS
        let totalCount = total.toString();
        window.webkit.messageHandlers.setCommentCount.postMessage(totalCount);
      }
    },
  },
  watch: {
    ktId: function (newVal) {
      let winHeight = document.documentElement.clientHeight; //视口大小
      document.getElementById("list-content").style.height =
        winHeight - 46 + "px"; //调整上拉加载框高度
      this.contentId = newVal;
      this.getTest();
    },
  },
};
</script>

<style lang="less">
@import "./css/discussBox.less";
</style>
